import {
  createSlugByIdName,
  createSlugByIdNamePractice,
  Env,
} from "../../../../utils/globalUtilities";
import { IndexName } from "../../../../constants/constants";
import { SearchItem } from "../../../../interface/SearchInterface";
import "./SearchResult.scss";
import { useEffect, useState } from "react";
import { SEARCH_API_CONSTANTS } from "../../../../constants/search.constanst";
import { getData, postData } from "../../../../services/global.service";
import { APIEnv, APIStatus } from "../../../../interface/baseInterfaces";
import LearningSearchResult from "./LearningSearchResult/LearningSearchResult";
import PraticeSearchResult from "./PraticeSearchResult/PraticeSearchResult";
import ResearchSearchResult from "./ResearchSearchResult/ResearchSearchResult";
import RightComponent from "../RightComponent/RightComponent";

export const SearchResult = ({
  result,
  searchQuery,
  searchString,
  activeTab,
  onViewAllClick,
  quickInfo
}: any) => {
  const [resultList, setResultList] = useState<any>([]);
  const [activeIndex, setActiveIndex] = useState(null)

  useEffect(() => {
    // modify intoducton for read more
    let searchResultFound = result;
    searchResultFound.map((data: any) => {
      if (data?.thirdLine?.length > 330) {
        data.shortIntroduction = data?.thirdLine?.slice(0, 330) + "...";
        data.showReadMore = true;
      } else {
        data.shortIntroduction = data?.thirdLine;
      }
  
      data.docIntro = [data?.thirdLine];
  
      if (data?.thirdLine?.length > 330) {
        data.shortTldData = data?.thirdLine?.slice(0, 330) + "...";
        data.showTLDReadMore = true;
      } else {
        data.shortTldData = data?.thirdLine;
      }
    });
    setResultList(searchResultFound);
  }, [result]);

  function getQuikInfoData(topicId: string, index: number, indexName: string) {
    let result = resultList[index];
    if (!result?.docIntro?.length) {
      if (indexName == IndexName.practice) {
        let params = {
          docId: topicId,
        };
        getData(SEARCH_API_CONSTANTS.DOC_INTRO, params, "", APIEnv.TAX_PRACTICE)
          .then((response: any) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
              if (response?.Data?.itemarray?.length > 0) {

                result.docIntro = response?.Data?.itemarray;
                setResultList([...resultList]);
              }
            }
          }
          ).catch(err => {
          })
      } else {
        // let params = {
        //   'Id': topicId
        // }
        // postData(SEARCH_API_CONSTANTS.TOP_STORY_INFO,
        //   params,
        //   APIEnv.NODE_PREMIUM).then((response: any) => {
        //     if (response?.ResponseType == APIStatus.SUCCESS) {
        //       if (response?.data?.date?.itemarray?.length > 0) {
        //         result.docIntro = response?.data?.date?.itemarray;
        //         setResultList([...resultList]);
        //       }
        //     }
        //   }
        //   ).catch(err => {
        //   })
      }
    }
  }

  const onClickPreview = (item: any) => {
    let url = window.location.origin + "/";
    let groupCat = (item.groupName.toLowerCase() == "read (ita 1961)") ? "read" : item.groupName.toLowerCase();
    if (item.Index == IndexName.practice) {
      url =
        url +
        "practice/" +
        createSlugByIdNamePractice(item.categoryName) +
        "/" +
        createSlugByIdName(item.heading) +
        "/" +
        groupCat +
        "/" +
        item.Id +
        "/" +
        ((groupCat == "read" || item.groupName.toLowerCase() == "read") ? "1" : "0") +
        "/" +
        "0" +
        (item.groupName.toLowerCase() === "read"
          ? `?cat=read${
            searchString || searchQuery
            ? `&searchData=${searchString || searchQuery}`
            : ""
          }`
          : item.groupName.toLowerCase() === "read (ita 1961)"
          ? `?cat=ITA1961${
            searchString || searchQuery
            ? `&searchData=${searchString || searchQuery}`
            : ""
          }`
          : searchString || searchQuery
          ? `?searchData=${searchString || searchQuery}`
          : ""
        );
      url += (url.includes("?") ? "&" : "?") + "platform=premium";
      window.open(url, "_blank");
    } else if (item.Index == IndexName.learning) {
      url =
        url +
        "learning" +
        "/" +
        item.Id +
        "-" +
        createSlugByIdName(item.heading);
      url += (url.includes("?") ? "&" : "?") + "platform=premium";
      window.open(url, "_blank");
    } else if (item.Index == IndexName.research) {
      url =
        url +
        "research/preview-document?categoryName=" +
        item.categoryUrl +
        "&fileId=" +
        item.Id +
        "&subCategory=" +
        item.groupUrl +
        (searchString || searchQuery
          ? "&searchText=" + (searchString || searchQuery)
          : "");
      url += (url.includes("?") ? "&" : "?") + "platform=premium";
      window.open(url, "_blank");
    }
  };

  const onClickReadMore = (item: any, index: number) => {
    let newItem = { ...item };

    if (newItem.showReadMore) {
      newItem.shortIntroduction = item?.thirdLine;
    } else {
      newItem.shortIntroduction = item?.thirdLine.slice(0, 330) + "...";
    }
    newItem.showReadMore = !newItem.showReadMore;
    let resultNew = [...resultList];
    resultNew[index] = newItem;
    setResultList([...resultNew]);
  };

  const onClickTLDReadMore = (item: any, index: number) => {
    let newItem = { ...item };
  
    const fullThirdLine = item.thirdLine;
  
    if (newItem.showTLDReadMore) {
      newItem.shortTldData = fullThirdLine;
    } else {
      newItem.shortTldData = fullThirdLine.slice(0, 330) + "...";
    }
  
    newItem.showTLDReadMore = !newItem.showTLDReadMore;
  
    let resultNew = [...resultList];
    resultNew[index] = newItem;
    setResultList(resultNew);
  };
  
const firstPracticeIndex = resultList?.findIndex((el:any) => el.Index == IndexName.practice)

  return (
    <>
      {resultList?.length
        ? resultList.map((item: SearchItem, index: number) =>
            Array.isArray(item) ? (
              <div
                key={`SearchResult${index}`}
                className="group-list video-list EEEEEEEEEEEEEEEEEEEE"
              >
                <div className="group-list-head">
                  <span className="group-list-title video-title">
                    {" "}
                    Videos on {searchQuery}
                  </span>
                </div>
                {item
                  .slice(0, activeTab === "Video" ? item.length : 3)
                  .map((learningItem: SearchItem, indexlearning: number) => (
                    <LearningSearchResult
                      key={`LearningSearchResultMap${indexlearning}`}
                      learningItem={learningItem}
                      index={indexlearning}
                      onClickPreview={onClickPreview}
                    />
                  ))}
                {activeTab !== "Video" && item.length > 3 && (
                  <div className="video-view-all">
                    <a
                      className="button-primary active cursor-pointer"
                      onClick={() => onViewAllClick("Video")}
                    >
                      {" "}
                      View All{" "}
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.1201 4.70361L14.1668 8.75028L10.1201 12.7969"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.83301 8.75049H14.053"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                )}
              </div>
            ) : item.Index == IndexName.learning ? (
              <div className="group-list video-list" key={`SearchResult${index}`}>
                <LearningSearchResult
                  learningItem={item}
                  index={index}
                  onClickPreview={onClickPreview}
                />
              </div>
            ) : item.Index == IndexName.practice ? (
              <div className="group-list" key={`SearchResult${index}`}>
                <PraticeSearchResult
                  practiceItem={item}
                  index={index}
                  onClickPreview={onClickPreview}
                  onClickReadMore={onClickReadMore}
                  getQuikInfoData={getQuikInfoData}
                  setActiveIndex={setActiveIndex}
                  activeIndex={activeIndex}
                />
                {
                  firstPracticeIndex == index && <span className="l-none"> <RightComponent info={quickInfo} /></span> 
                }
              </div>
            ) : (
              <div className="group-list" key={`SearchResult${index}`}>
                <ResearchSearchResult
                  researchItem={item}
                  index={index}
                  onClickPreview={onClickPreview}
                  onClickTLDReadMore={onClickTLDReadMore}
                  onClickReadMore={onClickReadMore}
                  getQuikInfoData={getQuikInfoData}
                />
              </div>
            )
          )
        : ""}
    </>
  );
};

export default SearchResult;
